import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { keyframes } from '@emotion/react';
import Box from '@mui/material/Box';
import { primaryMedium, backgroundGrey } from '@style/variables';

const navHeadingStyles = (theme) => ({
  color: theme.palette.neutral[50],
  padding: '1rem',
  fontFamily: theme.typography.h1.fontFamily,
  fontWeight: 'bold',
  fontSize: '1.5rem',
  lineHeight: '1.2',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  '&:hover': {
    color: theme.palette.primary.main,
  },
  [theme.breakpoints.only('sm')]: {
    padding: '1rem 0.5rem',
  },
});

export const NavHeadingLink = styled('a')(({ theme }) => navHeadingStyles(theme));

export const NavHeadingButton = styled('button')(({ theme }) => navHeadingStyles(theme));

const lineAnimation = keyframes`
  0% {
    transform: scaleX(0);
  }
  100% {
    transform: scaleX(1);
  }
`;

export const ActiveDropdownLine = styled('div')(({ theme }) => ({
  '&.active': {
    width: '100%',
    marginTop: '-5px',
    height: '4px',
    backgroundColor: theme.palette.primary.main,
    animation: `${lineAnimation} 450ms`,
  },
}));

export const MobileNavItem = styled(Box)(({ theme }) => ({
  display: 'block',
  fontFamily: theme.typography.h1.fontFamily,
  fontWeight: 'bold',
  fontSize: '1.5rem',
  textTransform: 'uppercase',
  width: '100%',
  color: theme.palette.neutral[800],
  letterSpacing: '0.2px',
  borderBottom: `1px solid rgba(0,0,0,0.1)`,
  '& li': {
    listStyle: 'none',
    fontFamily: 'inherit',
  },
}));

export const MobileSubnavItem = styled(Box)(({ theme, noBackground }) => ({
  fontFamily: theme.typography.body1.fontFamily,
  fontWeight: 'normal',
  textTransform: 'none',
  fontSize: '16px',
  lineHeight: '1.25rem',
  border: 'none',
  backgroundColor: noBackground ? 'white' : `${backgroundGrey}`,
  borderBottom: noBackground ? `1px solid rgba(0,0,0,0.1)` : 'none',
  display: 'block',
  padding: noBackground ? '1rem 3rem' : '1rem 4rem',
  width: '100%',
  '& li': {
    listStyle: 'none',
  },
}));

export const SecondaryNavText = (props) => (
  <Typography
    component="span"
    variant="h6"
    sx={{
      padding: '0.375rem 0.75rem',
      letterSpacing: '0.6px',
      fontSize: { xs: '1.5rem', md: '1rem' },
      lineHeight: { xs: '1.75rem', md: '1.25rem' },
      color: { md: 'white' },
    }}
    {...props}
  />
);

export const MobileFavoriteLink = styled('li')(({ theme }) => ({
  display: 'block',
  '& a': {
    textDecoration: 'underline',
    fontFamily: theme.typography.h1.fontFamily,
    fontSize: '1.5rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
}));

export const Tag = styled('span')`
  color: ${primaryMedium};
  text-transform: uppercase;
  font-size: 16px;
  font-family: 'Knockout', sans-serif;
  line-height: 1;
  letter-spacing: 1.14px;
  padding-left: 5px;
`;
